const grey = {
  colorGrey60: "#222939",
  colorGrey55: "#575c66",
  colorGrey50: "#6f7582",
  colorGrey40: "#ccd2e1",
  colorGrey30: "#e6e8f0",
  colorGrey20: "#f4f5f8",
  colorGrey10: "#fafbfc",
};

const green = {
  colorGreen60: "#21543d",
  colorGreen50: "#33845e",
  colorGreen48: "#32905e",
  colorGreen46: "#1ca140",
  colorGreen45: "#38a169",
  colorGreen40: "#20b94a",
  colorGreen30: "#69d391",
  colorGreen20: "#9be6b4",
  colorGreen10: "#e5fbec",
};

const purple = {
  colorPurple30: "#571abc",
  colorPurple20: "#712de2",
  colorPurple10: "#8144e5",
};

const black = {
  colorBlack: "000000",
};

const white = {
  colorWhite: "#ffffff",
};

const colors = {
  black,
  green,
  purple,
  grey,
  white,
};

export default colors;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/spocketUI/theme/colors.js